import { ResourceHeaders } from '..'
import {
  AppraisalStatusHeader,
  ContactHeader,
  IconHeader,
  IdHeader,
  TextHeader,
  VehicleHeader,
  VehicleStatusHeader,
} from '../../headers'
import { Helpers } from '@/views/datatables/resources/helpers'
import { extendsObj } from '@/utils/data'
import { TableCellHeader } from '@/components/dataTables/cell'
import { Inspection } from '@/entities/purchase'
import { Process } from '@/entities/settings'

export const headers: ResourceHeaders = [
  {
    ...IdHeader,
    text: 'Nº',
    value: '@',
    options: {
      expandOff: true,
      removeOff: true,
      action: {
        edit: Helpers.linkedModel,
      },
    },
    width: 130,
  },
  { ...TextHeader, text: 'Fecha creado', value: 'created', width: 120 },
  extendsObj<TableCellHeader>({
    text: 'Vehículo',
    value: '@',
    options: {
      path: 'autoStock.name',
      trigger: item => Helpers.linkedModel({ constructor: { name: 'StockPublish' }, ...item.stock }),
    },
  }, VehicleHeader),
  { ...AppraisalStatusHeader, text: 'Estado de habilitación', value: '@', width: 120 },
  { ...VehicleStatusHeader, text: 'Estado Stock', value: 'stock.status' },
  { ...TextHeader, text: 'Llave', value: 'stock.keyIdentifier.keyId', width: 120 },
  { ...IconHeader, text: 'Documentación', value: 'metadata.isDocumentationStatus', width: 100 },
  { ...IconHeader, text: 'Carrocería', value: 'metadata.isBodyWorkStatus', width: 100 },
  { ...IconHeader, text: 'Ruedas', value: 'metadata.isWheelsStatus', width: 100 },
  { ...IconHeader, text: 'Interior', value: 'metadata.isInsideStatus', width: 100 },
  { ...IconHeader, text: 'Mecánica', value: 'metadata.isMechanicalStatus', width: 100 },
  { ...IconHeader, text: 'Aseo', value: 'metadata.isCleanStatus', width: 100 },
  {
    ...TextHeader,
    text: 'Responsable',
    sortable: false,
    value: 'responsible.name',
  },
  {
    ...ContactHeader,
    text: 'Supervisor',
    sortable: false,
    value: '@',
    options: {
      disabledActionMissingProperty: {
        key: 'supervisor',
      },
      path: 'supervisor.name',
      action: {
        always: true,
        color: 'primary',
        icon: 'mdi-whatsapp',
        messaging: true,
        trigger: (item: Inspection, process: Process, system: string) => Helpers.contact(item, 'supervisor', process, system),
      },
      disabledMissingProperty: ['supervisor.phone'],
    },
  },
]

export default function (): ResourceHeaders {
  return headers
}
